import { useState, useEffect } from "react";
import authService from "../../services/auth-service";
import {
  Card,
  Tooltip,
  Zoom,
  IconButton,
  Autocomplete,
  TextField,
  FormControlLabel,
  Switch,
} from "@mui/material";
import {
  Delete,
  Edit,
  Error,
  Notifications,
  SettingsBackupRestore,
} from "@mui/icons-material";
import BTBox from "../../components/BTBox";
import BTButton from "../../components/BTButton";
import BTBadge from "../../components/BTBadge";
import BTInput from "../../components/BTInput";
import DashboardLayout from "../../Layouts/Layoutcontainers";
import EnhancedTable from "../../components/BTTable";
import Addstones from "./Addstones";
import Addungraded from "./Addungraded";
import ConfirmBox from "../../components/ConfirmBox";
import { stone_status } from "../../dropdownData";
import { useLoading, useNotification } from "../../context";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";
import { useSelector, useDispatch } from "react-redux";
import { get_parties, get_services, get_sizes } from "../../store/functions";
import { get, batchUpdate } from "../../store/labSlice";
import { additional_services } from "../../dropdownData";
import { fetchData } from "../../utils/fetchData";
import Swal from "sweetalert2";
const default_search = {
  type: 1,
  p_id: null,
  from_date: moment().subtract(1, "month").format("YYYY-MM-DD"),
  to_date: moment().add(1).format("YYYY-MM-DD"),
  rowsPerPage: 50,
  page: 1,
  searchText: null,
  last_id: 0,
  status: null,
  p_stn_id: null,
};
const CardHeader = ({
  setOpen,
  search,
  setSearch,
  tableType,
  setTableType,
  parties,
  clearState,
  sizes,
  services,
}) => {
  const [localDates, setLocalDates] = useState({
    from_date: search?.from_date || "",
    to_date: search?.to_date || "",
  });

  const handleDateChange = (field, value) => {
    const newDates = { ...localDates, [field]: value };
    setLocalDates(newDates);
    const timer = setTimeout(() => {
      clearState();
      setSearch({
        ...search,
        from_date: newDates.from_date,
        to_date: newDates.to_date,
        page: 1,
      });
    }, 500);

    return () => clearTimeout(timer);
  };

  const handleDownloadpdf = () => {
    const fileUrl = process.env.PUBLIC_URL + "files/sample_submition_file.xlsx";
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "sample file.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <Card sx={{ mb: 1 }}>
      <BTBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={2}
        sx={{
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
          gap: 2,
        }}>
        <BTBox
          display="flex"
          alignItems="center"
          sx={{
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
            width: { xs: "100%", sm: "auto" },
          }}>
          <FormControlLabel
            control={
              <Switch
                checked={tableType}
                onChange={() => {
                  clearState();
                  setTableType(!tableType);
                  setSearch({
                    ...default_search,
                    type: tableType ? 1 : 2,
                  });
                }}
                size="small"
                color="secondary"
              />
            }
            label={"All records"}
            labelPlacement="end"
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
            }}
          />
          <Autocomplete
            options={parties || []}
            getOptionLabel={(option) => option?.p_name || ""}
            getOptionKey={(option) => option.p_id}
            onChange={(event, value) => {
              clearState();
              setSearch({ ...search, p_id: value?.p_id, page: 1 });
            }}
            sx={{ width: "100%" }}
            value={parties?.find(({ p_id }) => p_id === search?.p_id) || null}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Party"
                size="small"
                variant="standard"
                sx={{ width: { xs: "100%", sm: "150px" } }}
              />
            )}
          />
          {tableType && (
            <Autocomplete
              options={sizes || []}
              getOptionLabel={(option) =>
                `${option?.size_from} - ${option?.size_to}`
              }
              sx={{ width: "100%" }}
              disabled={false}
              multiple={true}
              onChange={(event, value) => {
                clearState();
                setSearch({
                  ...search,
                  sizes: value?.map(({ size_id }) => size_id) || null,
                  page: 1,
                });
              }}
              value={sizes?.filter(
                ({ size_id }) => search?.sizes?.includes(size_id) || null
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Size"
                  size="small"
                  variant="standard"
                  sx={{ width: { xs: "100%", sm: "150px" } }}
                />
              )}
            />
          )}

          {tableType && (
            <Autocomplete
              options={stone_status || []}
              getOptionLabel={(option) => option?.label || ""}
              value={stone_status?.filter(
                ({ value }) => search?.status?.includes(value) || null
              )}
              onChange={(event, value) => {
                clearState();
                setSearch({
                  ...search,
                  status: value?.map(({ value }) => value) || null,
                  page: 1,
                });
              }}
              sx={{ width: "100%" }}
              multiple={true}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="status"
                  size="small"
                  variant="standard"
                  sx={{ width: { xs: "100%", sm: "150px" } }}
                />
              )}
            />
          )}
          {tableType && (
            <Autocomplete
              options={additional_services || []}
              getOptionLabel={(option) => option?.label || ""}
              value={additional_services?.filter(
                ({ value }) =>
                  search?.additional_services?.includes(value) || null
              )}
              onChange={(event, value) => {
                clearState();
                setSearch({
                  ...search,
                  additional_services: value?.map(({ value }) => value) || null,
                  page: 1,
                });
              }}
              sx={{ width: "100%" }}
              multiple={true}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Additional service"
                  size="small"
                  variant="standard"
                  sx={{ width: { xs: "100%", sm: "150px" } }}
                />
              )}
            />
          )}
          {tableType && (
            <Autocomplete
              options={services || []}
              getOptionLabel={(option) => option?.ser_name || ""}
              value={services?.filter(
                ({ ser_id }) => search?.services?.includes(ser_id) || null
              )}
              onChange={(event, value) => {
                clearState();
                setSearch({
                  ...search,
                  services: value?.map(({ ser_id }) => ser_id) || null,
                  page: 1,
                });
              }}
              sx={{ width: "100%" }}
              multiple={true}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="service"
                  size="small"
                  variant="standard"
                  sx={{ width: { xs: "100%", sm: "150px" } }}
                />
              )}
            />
          )}
          <BTInput
            size="small"
            type="date"
            label="From Date"
            value={localDates.from_date}
            onChange={(e) => handleDateChange("from_date", e.target.value)}
            variant="standard"
            sx={{ width: "100%" }}
          />

          <BTInput
            size="small"
            type="date"
            label="To Date"
            value={localDates.to_date}
            onChange={(e) => handleDateChange("to_date", e.target.value)}
            variant="standard"
            sx={{ width: "100%" }}
          />
        </BTBox>
        <BTBox display="flex" gap={1}>
          <BTButton
            variant="gradient"
            size="small"
            fullWidth
            color="dark"
            onClick={handleDownloadpdf}
            sx={{ width: { xs: "100%", sm: "auto" } }}>
            sample file
          </BTButton>
          <BTButton
            variant="gradient"
            size="small"
            fullWidth
            color="dark"
            onClick={() => setOpen({ show: true, actionType: 1 })}
            sx={{ width: { xs: "100%", sm: "auto" } }}>
            Add
          </BTButton>
        </BTBox>
      </BTBox>
    </Card>
  );
};
const ExpandComponent = ({ row, expandColumns, submission, subRefresh }) => {
  const [subRecords, setSubRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState({
    type: 2,
    p_stn_id: row?.stn_id,
    p_id: null,
    from_date: null,
    to_date: null,
    rowsPerPage: 50000000,
    page: 1,
    searchText: null,
    last_id: 0,
  });
  useEffect(() => {
    const localSubs = submission?.filter(
      (i) => i?.p_stn_id && i?.stn_type == 2 && i?.p_stn_id == row.stn_id
    );
    if (localSubs?.length > 0) {
      setSubRecords(localSubs);
    } else {
      fetchSubs();
    }
  }, [row, submission, subRefresh]);
  const fetchSubs = async () => {
    try {
      const response = await fetchData({
        api: "get_submissions",
        name: "submission",
        key: "stn_id",
        searchParams: search,
        filterCallback: null,
        showLoading: () => setLoading(true),
        hideLoading: () => setLoading(false),
        hold: false,
      });

      if (response?.status) {
        setSubRecords(response?.data);
      }
    } finally {
    }
  };
  return (
    <EnhancedTable
      rows={subRecords}
      loading={loading}
      columns={expandColumns}
      tableHeader={true}
      title="Submissions Details"
    />
  );
};

const Submission = () => {
  const loginUser = secureLocalStorage.getItem("userdata");
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useLoading();
  const { addNotification } = useNotification();
  const parties = useSelector((state) => state?.lab?.parties);
  const services = useSelector((state) => state?.lab?.services);
  const sizes = useSelector((state) => state?.lab?.sizes);
  const submission = useSelector((state) => state?.lab?.submission);
  const [open, setOpen] = useState(null);
  const [tableType, setTableType] = useState(false);
  const [ungraded, setUngraded] = useState(null);
  const [loading, setLoading] = useState(false);
  const [subRefresh, setSubRefresh] = useState(false);
  const [search, setSearch] = useState(default_search);
  let pageIndex = submission?.pages?.findIndex((p) => p.page === search.page);
  const startIndex = pageIndex !== -1 ? pageIndex * search.rowsPerPage : 0;
  const endIndex = startIndex + search.rowsPerPage;
  useEffect(() => {
    !parties?.is_fetch && get_parties();
    !services?.is_fetch && get_services();
    !sizes?.is_fetch && get_sizes();
  }, []);

  useEffect(() => {
    fetchSubmission();
  }, [search]);

  const handleSearch = (data, searchData) => {
    const filterBySearch = data?.filter((item) => {
      const searchText = searchData?.searchText?.toLowerCase().trim() || "";
      const matchText =
        item?.stn_desc?.toLowerCase()?.includes(searchText) ||
        String(item?.sub_count)?.toLowerCase()?.includes(searchText) ||
        String(item?.sub_weight)?.toLowerCase()?.includes(searchText);
      const matchFilters =
        item?.stn_type === searchData?.type &&
        (searchData?.p_id ? item?.p_id === searchData?.p_id : true) &&
        moment(item.stn_date, "YYYY-MM-DD").isBetween(
          moment(searchData?.from_date, "YYYY-MM-DD").startOf("day"),
          moment(searchData?.to_date, "YYYY-MM-DD").endOf("day"),
          null,
          "[]"
        );
      return matchText && matchFilters;
    });
    const paginateData = filterBySearch?.slice(startIndex, endIndex);
    return paginateData;
  };
  const handleUnGraded = async (row) => {
    Swal.fire({
      title: "Are you sure to ungraded this stone",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, ungraded it!",
      confirmButtonColor: "black",
      button: {
        text: "Confirm!",
        closeModal: false,
        color: "info",
      },
      zIndex: "100000000",
    }).then(async (res) => {
      if (res?.isConfirmed) {
        try {
          let response = await authService?.ungraded_submit_return({
            attributes: { ...row, stn_status: 15 },
          });
          if (response?.status) {
            if (!tableType) {
              setSubRefresh(!subRefresh);
            } else {
              dispatch(
                batchUpdate({
                  name: "submission",
                  key: "stn_id",
                  insert: [],
                  updateItems: response?.data,
                  removeItems: [],
                })
              );
            }
          }
        } catch (error) {
          addNotification({
            title: "#Error",
            message: error?.message || "Something went wrong",
            type: "error",
            color: "error",
            icon: <Error fontSize="small" color="white" />,
          });
        }
      }
    });
  };
  const handleDeleteStone = async (row) => {
    Swal.fire({
      title: `Are you sure to delete this stone ${row?.stn_cus_ref_no}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "red",
      zIndex: "100000000",
    }).then(async (res) => {
      if (res?.isConfirmed) {
        try {
          const response = await authService?.delete_submission({
            attributes: row,
          });
          if (response?.status) {
            if (!tableType) {
              const { stn_cts, stn_pcs, stn_id, p_stn_id } = response?.data;
              const mainRec = submission?.data?.find(
                ({ stn_id }) => stn_id === p_stn_id
              );
              const updateRec = {
                ...mainRec,
                stn_cts: mainRec?.stn_cts - stn_cts,
                stn_pcs: mainRec?.stn_pcs - stn_pcs,
              };
              dispatch(
                batchUpdate({
                  name: "submission",
                  key: "stn_id",
                  insert: [],
                  updateItems: updateRec,
                  removeItems: [],
                })
              );
              setSubRefresh(!subRefresh);
            } else {
              dispatch(
                batchUpdate({
                  name: "submission",
                  key: "stn_id",
                  insert: [],
                  updateItems: [],
                  removeItems: response?.data,
                })
              );
            }
            addNotification({
              title: "Sucessfully",
              message: response?.message,
              type: "success",
              color: "success",
              icon: <Notifications fontSize="small" color="white" />,
            });
          }
        } catch (error) {
          addNotification({
            title: "#Error",
            message: error?.message || "Something went wrong",
            type: "error",
            color: "error",
            icon: <Error fontSize="small" color="white" />,
          });
        }
      }
    });
  };
  const fetchSubmission = async () => {
    await fetchData({
      api: "get_submissions",
      name: "submission",
      key: "stn_id",
      searchParams: search,
      filterCallback: handleSearch,
      showLoading: () => setLoading(true),
      hideLoading: () => setLoading(false),
      hold: true,
    });
  };

  //   Compoennt
  const Actions = ({ row }) => {
    return (
      <BTBox display="flex" flexDirection="row" gap={1}>
        {loginUser?.p_delete?.submit === 1 && (
          <Tooltip title="Edit">
            {/* <IconButton
            size="small"
            onClick={async () => {
              const response = await get_sub_data(row?.stn_id);
              if (response) {
                setOpen({
                  actionType: 2,
                  show: true,
                  value: {
                    ...row,
                    stn_submits: response,
                  },
                });
              } else {
                addNotification({
                  message: response?.message?.message || "Something went wrong",
                  type: "error",
                  color: "error",
                  icon: <Error fontSize="small" color="white" />,
                });
              }
            }}
          > */}
            <Edit
              color="warning"
              sx={{ cursor: "pointer", fontSize: "18px" }}
              onClick={async () => {
                try {
                  const response = await fetchData({
                    api: "get_submissions",
                    name: "submission",
                    key: "stn_id",
                    searchParams: {
                      ...default_search,
                      from_date: null,
                      to_date: null,
                      rowsPerPage: 501000000,
                      p_stn_id: row?.stn_id,
                    },
                    filterCallback: null,
                    showLoading,
                    hideLoading,
                    hold: false,
                  });
                  if (response?.status) {
                    setOpen({
                      actionType: 2,
                      show: true,
                      value: {
                        ...row,
                        stn_submits: response?.data,
                      },
                    });
                  } else {
                    addNotification({
                      message: response?.message || "Something went wrong",
                      type: "error",
                      color: "error",
                      icon: <Error fontSize="small" color="white" />,
                    });
                  }
                } catch (error) {}
              }}
            />
            {/* </IconButton> */}
          </Tooltip>
        )}

        {/* <Tooltip title="Delete" TransitionComponent={Zoom}>
          <IconButton
            size="small"
            onClick={() => {
              const data = submissions?.data?.filter(
                ({ p_stn_id, stn_deleted }) =>
                  p_stn_id === row?.stn_id && !stn_deleted
              );
              if (data?.length > 0) {
                addNotification({
                  icon: <Error color="white" />,
                  title: "Error",
                  message:
                    "Deletion is not allowed as this record includes a sub-submissions.",
                  color: "error",
                });
                return;
              }
              setDelete(row);
            }}
          >
            <Delete fontSize="12px" color="error" />
          </IconButton>
        </Tooltip> */}
      </BTBox>
    );
  };

  const expandColumns = [
    {
      id: "id",
      name: "ID",
      selector: (row, index) => index + 1,
      value: (row) => row?.stn_id,
      width: "50px",
      numeric: false,
      sortable: true,
    },
    {
      id: "stn_prefix_ref_no",
      name: "Prefix No",
      selector: (row) => row?.stn_prefix_ref_no,
      width: "100px",
      sortable: true,
    },
    {
      id: "stn_cus_ref_no",
      name: "Customer Ref No",
      selector: (row) => row?.stn_cus_ref_no,
      width: "100px",
      sortable: true,
    },
    {
      id: "stn_pcs",
      name: "Pcs",
      selector: (row) => row?.stn_pcs,
      width: "50px",
      sortable: true,
    },
    {
      id: "p_id",
      name: "Party",
      selector: (row) =>
        parties?.data?.find(({ p_id }) => p_id === row?.p_id)?.p_name,
      numeric: false,
      sortable: true,
      width: "200px",
    },
    {
      id: "p_code",
      name: "Party code",
      selector: (row) =>
        parties?.data?.find(({ p_id }) => p_id === row?.p_id)?.p_code,
      sortable: true,
      width: "100px",
    },
    {
      id: "stn_cts",
      name: "Weight",
      selector: (row) => Number(row?.stn_cts)?.toFixed(2),
      width: "50px",
      sortable: true,
    },
    {
      id: "lab_cts",
      name: "Lab Weight",
      selector: (row) => row?.lab_cts,
      width: "50px",
      sortable: true,
    },
    {
      id: "size",
      name: "Size",
      selector: (row) => {
        const weight = row?.stn_cts;
        const size = sizes?.data?.find(
          ({ size_from, size_to }) => weight >= size_from && weight <= size_to
        );
        if (size) {
          return `${Number(size?.size_from)?.toFixed(2)} - ${Number(
            size?.size_to
          )?.toFixed(2)}`;
        } else {
          return "-";
        }
      },
      width: "100px",
    },
    {
      id: "services",
      name: "Services",
      selector: (row) => {
        const joinedString = row?.stn_services
          ?.map((item) => item.ser_name)
          .join(", ");
        return joinedString;
      },
      width: "150px",
    },
    {
      id: "aditional_services",
      name: "Aditional Services",
      selector: (row) => {
        let services = [];
        if (row?.stn_without_plot) {
          services?.push("Without Plotting");
        }
        if (row?.stn_tatkal) {
          services?.push("Tatkal");
        }
        if (row?.stn_color) {
          services?.push("Color");
        }
        return services?.join(",");
      },
      width: "150px",
    },
    {
      id: "stn_date",
      name: "Date",
      selector: (row) =>
        moment(row?.stn_date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY"),
      width: "100px",
      sortable: true,
    },
    {
      id: "stn_status",
      name: "Status",
      value: (row) => {
        const name = stone_status?.find(
          ({ value }) => value === row?.stn_status
        )?.label;
        return name;
      },
      selector: (row) => {
        const name = stone_status?.find(
          ({ value }) => value === row?.stn_status
        )?.label;
        return (
          <BTBadge badgeContent={name} size="xs" container color="success" />
        );
      },
      width: "100px",
      sortable: true,
    },
    {
      id: "stn_desc",
      name: "Description",
      selector: (row) => row?.stn_desc,
      width: "100px",
    },
    {
      id: "actions",
      name: "Actions",
      value: () => "",
      selector: (row) => (
        <BTBox display="flex" flexDirection="row" gap={1} alignItems="center">
          {[1, 5, 10].includes(row?.stn_status) &&
            loginUser?.p_delete?.submit === 1 && (
              <Tooltip title="Delete" TransitionComponent={Zoom}>
                <Delete
                  color="error"
                  onClick={() => handleDeleteStone(row)}
                  sx={{ cursor: "pointer", fontSize: "18px" }}
                />
              </Tooltip>
            )}

          {row?.stn_status === 1 && (
            <Tooltip title="Ungraded">
              <SettingsBackupRestore
                color="info"
                sx={{ fontSize: "18px", cursor: "pointer" }}
                onClick={() => handleUnGraded(row)}
              />
            </Tooltip>
          )}
        </BTBox>
      ),
      width: "50px",
    },
  ];
  const columns = [
    {
      id: "id",
      name: "ID",
      selector: (row, index) => index + 1,
      value: (row) => row?.stn_id,
      width: "50px",
      numeric: false,
      sortable: true,
    },
    {
      id: "stn_pcs",
      name: "Number of Stones",
      selector: (row) => row?.stn_pcs,
      sortable: true,
    },
    {
      id: "p_id",
      name: "Party",
      selector: (row) =>
        parties?.data?.find(({ p_id }) => p_id === row?.p_id)?.p_name,
      numeric: false,
      sortable: true,
    },
    {
      id: "p_code",
      name: "Party code",
      selector: (row) =>
        parties?.data?.find(({ p_id }) => p_id === row?.p_id)?.p_code,
      sortable: true,
    },
    {
      id: "stn_cts",
      name: "Weight",
      selector: (row) => Number(row?.stn_cts).toFixed(2),
      sortable: true,
    },
    {
      id: "stn_date",
      name: "Date",
      selector: (row) =>
        moment(row?.stn_date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY"),
      sortable: true,
    },
    {
      id: "stn_desc",
      name: "Description",
      selector: (row) => row?.stn_desc,
    },
    {
      id: "actions",
      name: "Actions",
      value: () => "",
      selector: (row) => <Actions row={row} />,
    },
  ];

  // new

  const clearState = () => {
    dispatch(
      get({
        name: "submission",
        data: [],
        pages: [],
        total: 0,
        fetch: false,
      })
    );
  };
  const renderData = submission?.data?.filter(
    ({ stn_type }) => stn_type === search?.type
  );

  return (
    <DashboardLayout>
      <CardHeader
        search={search}
        setSearch={setSearch}
        setOpen={setOpen}
        tableType={tableType}
        setTableType={setTableType}
        parties={parties?.data}
        clearState={clearState}
        sizes={sizes?.data}
        setLoading={setLoading}
        services={services?.data}
      />
      <EnhancedTable
        columns={tableType ? expandColumns : columns}
        loading={loading}
        tableHeader={true}
        rows={renderData?.slice(startIndex, endIndex)}
        initialPage={search?.page}
        totalRows={submission?.total}
        title="Submissions"
        defaultSort="carbs"
        pagination={true}
        expandComponent={
          <ExpandComponent
            expandColumns={expandColumns}
            clearState={clearState}
            submission={submission?.data}
            subRefresh={subRefresh}
          />
        }
        fetchData={{
          fnc: fetchData,
          params: {
            api: "get_submissions",
            searchParams: {
              ...search,
              page: 1,
              rowsPerPage: submission?.total,
            },
            filterCallback: null,
            name: "submission",
            key: "stn_id",
            showLoading,
            hideLoading,
            hold: false,
          },
        }}
        expandRow={tableType ? false : true}
        checkBoxSelected={false}
        serverSidePagination={true}
        serverSideSearch={true}
        onPageChange={({ page, rowsPerPage, searchText }) => {
          if (search?.rowsPerPage !== rowsPerPage) {
            clearState();
          }
          setSearch({
            ...search,
            page,
            rowsPerPage,
            searchText,
            last_id: submission?.pages[pageIndex]?.next_last_id,
          });
        }}
        onSearchChange={(searchText, { page, rowsPerPage }) => {
          clearState();
          setSearch((prev) => ({ ...prev, searchText, page, rowsPerPage }));
        }}
      />
      {open && (
        <Addstones
          open={open}
          setOpen={setOpen}
          parties={parties?.data}
          services={services?.data}
          sizes={sizes?.data}
          type={tableType}
        />
      )}
      {Boolean(ungraded) && (
        <Addungraded row={ungraded} setUngraded={setUngraded} />
      )}
    </DashboardLayout>
  );
};
export default Submission;
